import React, { useState } from 'react';
import { connect, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import webtitleImg from '../../assets/images/brand/title.png';
import { EXCH_COMPETITIONS_MENU } from '../../constants/CommonConstants';
import { DomainConfig } from '../../models/DomainConfig';
import { SelectedObj } from '../../models/ExchangeSportsState';
import { RootState } from '../../models/RootState';
import { CompetitionDTO } from '../../models/common/CompetitionDTO';
import { EventDTO } from '../../models/common/EventDTO';
import { ReactComponent as profile } from '../../assets/images/icons/profile.svg';
import ExpandIcon from '../../assets/images/icons/expandIcon.svg';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import ArrowDropUpIcon from '@material-ui/icons/ArrowDropUp';
import {
  setAlertMsg,
  setLangData,
  setLangSelected,
  setLanguages,
} from '../../store/common/commonActions';
import { KeyboardArrowDown, KeyboardArrowUp } from '@material-ui/icons';
import {
  fetchCompetitions,
  fetchEventsByCompetition,
  getCompetitionsByEventType,
  logout,
  setCompetition,
} from '../../store';
import {
  JwtToken,
  demoUser,
  getFieldFromToken,
  notDemoUser,
} from '../../util/stringUtil';
import SocialMediaNew from '../SocialMedia/SocialMedia';
import './SideHeader.scss';
import {
  casinoHeaderTabs,
  otherMenuTabs,
  securityAndLogout,
  sideHeaderTabs,
  sportsHeaderTabs,
} from './SideHeaderUtil';
import { findByLabelText } from '@testing-library/react';
import { getLangCode } from '../../util/localizationUtil';
import TranslateIcon from '@material-ui/icons/Translate';
type Props = {
  loggedIn: boolean;
  logout: Function;
  fetchCompetitions: (eventTypeId: string) => void;
  fetchEventsByCompetition: (
    eventTypeId: string,
    competitionId: string,
    events: EventDTO[],
    track: string
  ) => void;
  setCompetition: (competition: SelectedObj) => void;
  competitions: CompetitionDTO[];
  domainConfig: DomainConfig;
  closeHandler?: Function;
  languages: string[];
  langSelected: string;
  setLangSelected: (lang: string) => void;
  langData: any;
};

const SideHeader = (props: Props) => {
  const {
    loggedIn,
    logout,
    fetchCompetitions,
    fetchEventsByCompetition,
    competitions,
    domainConfig,
    setCompetition,
    closeHandler,
    languages,
    langSelected,
    setLangSelected,
  } = props;

  const [openLanguages, setOpenLanguages] = useState<boolean>(false);
  const history = useHistory();

  const getCompetitionsBySport = (id) => {
    fetchCompetitions(id);
  };

  const getUserShortName = () => {
    const name: string = demoUser()
      ? 'Demo User'
      : getFieldFromToken(JwtToken.SUBJECT_NAME);
    return name ? name[0].toUpperCase() : '';
  };

  const handleImgClick = () => {
    closeHandler && closeHandler();
    history.push('/home');
  };
  const langData = useSelector((state: RootState) => state.common.langData);
  const handleLangChange = (langParam: string) => {
    // console.log(langParam)
    sessionStorage.setItem('lang', langParam);
    setLangSelected(sessionStorage.getItem('lang'));
    window.location.reload();
  };
  return (
    <div className="side-header">
      <div className="sh-menu">
        <div className="sh-sub-menu">
          <div className="sh-sub-title">{langData?.['menu']}</div>
        </div>
        <div className="changeLanguagee">
          {languages.length > 0 && (
            <div className="lang-select-menuu">
              <div className="lang-selectt">
                <TranslateIcon className="translate-icon" />
                <div className="langg blink">Language</div>
                {openLanguages ? (
                  <span onClick={() => setOpenLanguages(false)}>
                    <KeyboardArrowUp className="dropdown-iconn" />
                  </span>
                ) : (
                  <span onClick={() => setOpenLanguages(true)}>
                    <KeyboardArrowDown className="dropdown-iconn" />
                  </span>
                )}
              </div>
              {openLanguages && (
                <div className="lang-menuu">
                  {languages.map((language, index) => (
                    <div
                      key={index}
                      className="lang-menu-optionn"
                      onClick={() => {
                        handleLangChange(language);
                        setOpenLanguages(false); // Close menu after selection
                      }}
                    >
                      {language.replace('(', ' (')}
                    </div>
                  ))}
                </div>
              )}
            </div>
          )}
        </div>
        <div className="sh-sub-menu">
          <SHSportsTab
            tabs={sideHeaderTabs}
            loggedIn={loggedIn}
            getCompetitionsBySport={getCompetitionsBySport}
            competitions={competitions}
            fetchEventsByCompetition={fetchEventsByCompetition}
            setCompetition={setCompetition}
            closeHandler={closeHandler}
          />
        </div>
        {domainConfig.sportsEnabled ? (
          <div className="sh-sub-menu">
            <SHSportsTab
              tabs={sportsHeaderTabs}
              loggedIn={loggedIn}
              getCompetitionsBySport={getCompetitionsBySport}
              competitions={competitions}
              fetchEventsByCompetition={fetchEventsByCompetition}
              setCompetition={setCompetition}
              closeHandler={closeHandler}
            />
          </div>
        ) : null}

        {domainConfig.casinoEnabled ? (
          <div className="sh-sub-menu">
            <SHSportsTab
              tabs={casinoHeaderTabs}
              loggedIn={loggedIn}
              getCompetitionsBySport={getCompetitionsBySport}
              competitions={competitions}
              fetchEventsByCompetition={fetchEventsByCompetition}
              setCompetition={setCompetition}
              closeHandler={closeHandler}
            />
          </div>
        ) : null}
    
    {domainConfig.payments ? (
    <div className="sh-sub-menu">
          <div className="sh-sub-title">Other menu</div>
          <div className="sh-sub-menu">
          <SportTab
            tabs={otherMenuTabs}
            loggedIn={loggedIn}
            domainConfig={domainConfig}
            closeHandler={closeHandler}
          />
          </div>
        </div>
     ) : null}

        <div className="sh-sub-menu">
          <div className="sh-sub-title">{langData?.['rules']}</div>
        </div>
        <div className="sh-sub-menu">
          <SHTab
            tabs={securityAndLogout}
            loggedIn={loggedIn}
            logout={() => logout()}
            closeHandler={closeHandler}
          />
        </div>
      </div>

    </div>
  );
};

const SHTab = (props: {
  tabs;
  loggedIn;
  logout?;
  domainConfig?: DomainConfig;
  closeHandler: Function;
}) => {
  const { loggedIn, tabs, logout, domainConfig, closeHandler } = props;
  const history = useHistory();
  const langData = useSelector((state: RootState) => state.common.langData);
  const handleClick = (indv) => {
    if (indv.id === 22) {
      logout();
      return;
    }
    closeHandler && closeHandler();
    history.push(indv.route);
  };

  const shouldShow = (indv) => {
    if (indv.id === 9 || indv.id === 10) {
      return loggedIn && domainConfig?.payments && notDemoUser();
    }
    if (indv.id === 18 || indv.id === 16) {
      return loggedIn && domainConfig?.bonus;
    }
    return indv.showWithoutLogin || loggedIn;
  };

  return (
    <>
      {tabs.map(
        (indv) =>
          shouldShow(indv) && (
            <button
              className={`${
                indv.route === window.location.pathname ? 'active-sh-btn' : ''
              } sh-rules-btn`}
              onClick={() => handleClick(indv)}
            >
              <indv.img
                className={`sh-img ${
                  indv.text.toLowerCase() === 'logout' ? 'logout-icon' : ''
                }`}
                alt=""
              />
              <div className="sh-tab-label">{langData?.[indv.langKey]}</div>
            </button>
          )
      )}
    </>
  );
};
const SportTab = (props: {
  tabs;
  loggedIn;
  logout?;
  domainConfig?: DomainConfig;
  closeHandler: Function;
}) => {
  const { loggedIn, tabs, logout, domainConfig, closeHandler } = props;
  const history = useHistory();
  const langData = useSelector((state: RootState) => state.common.langData);
  const handleClick = (indv) => {
    if (indv.id === 22) {
      logout();
      return;
    }
    closeHandler && closeHandler();
    history.push(indv.route);
  };

  const shouldShow = (indv) => {
    if (indv.id === 9 || indv.id === 10) {
      return loggedIn && domainConfig?.payments && notDemoUser();
    }
    if (indv.id === 18 || indv.id === 16) {
      return loggedIn && domainConfig?.bonus;
    }
    return indv.showWithoutLogin || loggedIn;
  };

  return (
    <>
      {tabs.map(
        (indv) =>
          shouldShow(indv) && (
            <button
            className={`${
              window.location.pathname.includes(indv.route)
                ? 'active-sh-btn'
                : ''
            } sh-btn`}
              onClick={() => handleClick(indv)}
            >
              <indv.img
                className={`sh-img ${
                  indv.text.toLowerCase() === 'logout' ? 'logout-icon' : ''
                }`}
                alt=""
              />
              <div className="sh-tab-label">{langData?.[indv.langKey]}</div>
            </button>
          )
      )}
    </>
  );
};

const SHSportsTab = (props: {
  tabs;
  loggedIn;
  logout?;
  getCompetitionsBySport;
  competitions;
  fetchEventsByCompetition;
  setCompetition;
  closeHandler;
}) => {
  const {
    loggedIn,
    tabs,
    logout,
    getCompetitionsBySport,
    competitions,
    fetchEventsByCompetition,
    setCompetition,
    closeHandler,
  } = props;
  const history = useHistory();
  const langData = useSelector((state: RootState) => state.common.langData);
  const [selcompetition, setSelCompetition] = useState<any>(null);
  const [showDropDown, setShowDropDown] = useState<boolean>(false);
  const [selSport, setSelSport] = useState<any>(null);
  const [expandedTab, setExpandedTab] = useState(null); // State to track expanded tab
  const notSports = [
    'Inplay',
    'Sportsbook',
    'Live Casino',
    'Big Bash',
    'Home',
    'Aviator',
    'Indian Casino',
    'Multi markets',
    'Royal Gaming',
    'Ezugi',
    'Evolution',
    'Mac88',
    'Monk88',
    'Lankesh',
    'Crash88',
    'Spribe',
    'IPL'
  ];

  const handleClick = (indv) => {
    // selSport && indv.id === selSport
    //   ? setShowDropDown(false)
    //   : setShowDropDown(true);
    console.log('indv', indv);
    if (notSports.includes(indv.text)) {
      closeHandler();
    } else {
      setShowDropDown(!showDropDown);
    }
    setSelSport(indv.id);
    getCompetitionsBySport(indv.id);
    history.push(indv.route);
  };

  const handleCompetitionClick = (indv, compt) => {
    setSelCompetition(compt.id);
    setCompetition({ id: compt.id, name: compt.name, slug: compt.slug });
    fetchEventsByCompetition(
      indv.id,
      compt.id,
      undefined,
      EXCH_COMPETITIONS_MENU
    );
    closeHandler && closeHandler();
    history.push(`/exchange_sports/${indv.text}/${compt.slug}`);
  };

  const handleToggle = (tabId) => {
    setExpandedTab((prev) => (prev === tabId ? null : tabId)); // Toggle the tab
  };
  return (
    <>
      {tabs.map(
        (indv) =>
          (indv.showWithoutLogin || loggedIn) && (
            <>
              <button
                className={`${
                  window.location.pathname.includes(indv.route)
                    ? 'active-sh-btn'
                    : ''
                } sh-btn`}
                onClick={() => {
                  handleClick(indv);
                  handleToggle(indv.id); // Toggle dropdown visibility
                }}
              >
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <indv.img className="sh-img" alt="" />
                  <div
                    className={`sh-tab-label ${
                      indv.text === 'Big Bash' ||
                      indv.text === 'IPL'
                        ? 'blink'
                        : ''
                    }`}
                  >
                    {langData?.[indv.langKey]}
                  </div>
                </div>
                {!notSports.includes(indv.text) && (
                  <div className="expand-icon-sideheader">
                    {expandedTab === indv.id ? (
                      <ArrowDropUpIcon />
                    ) : (
                      <ArrowDropDownIcon />
                    )}
                  </div>
                )}
              </button>
              {window.location.pathname?.includes(indv.route) &&
                expandedTab === indv.id && // Show dropdown only if expanded
                competitions?.map(
                  (competition) =>
                    indv.id === competition.sportId && (
                      <button
                        className={`indv-competition ${
                          selcompetition === competition.id
                            ? 'indv-competition-active'
                            : ''
                        }`}
                        onClick={() => {
                          handleCompetitionClick(indv, competition);
                        }}
                      >
                        {competition.name}
                      </button>
                    )
                )}
            </>
          )
      )}
    </>
  );
};

const mapStateToProps = (state: RootState) => {
  return {
    loggedIn: state.auth.loggedIn,
    competitions: getCompetitionsByEventType(
      state.exchangeSports.competitions,
      state.exchangeSports.selectedEventType.id
    ),
    domainConfig: state.common.domainConfig,
    langSelected: state.common.langSelected,
    languages: state.common.languages,
    langData: state.common.langData,
  };
};

const mapDispatchToProps = (dispatch: Function) => {
  return {
    logout: () => dispatch(logout()),
    fetchCompetitions: (eventTypeId: string) =>
      dispatch(fetchCompetitions(eventTypeId)),
    fetchEventsByCompetition: (
      eventTypeId: string,
      competitionId: string,
      events: EventDTO[],
      track: string
    ) =>
      dispatch(
        fetchEventsByCompetition(eventTypeId, competitionId, events, track)
      ),
    setCompetition: (competition: SelectedObj) =>
      dispatch(setCompetition(competition)),
    setLangSelected: (lang: string) => dispatch(setLangSelected(lang)),
    setLanguages: (languages: string[]) => dispatch(setLanguages(languages)),
    setLangData: (langData: any) => dispatch(setLangData(langData)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(SideHeader);
